import { type IMycleContentCategory } from '../model'

export const ALL_TOPIC_FILTER = '전체' as const

/** 주제별 콘텐츠 인피니트 스크롤 페이지 사이즈 */
export const TOPIC_CONTENTS_PAGE_SIZE = 10

export const TOPIC_SORT_OPTIONS = ['최신순', '인기순', '오래된 순'] as const

export type TTopicSort = (typeof TOPIC_SORT_OPTIONS)[number]

/**
 * UI sort 라벨 → mycleContent API의 pageable.sort 파라미터 값 매핑
 * - 최신순: createTime,desc (기본)
 * - 오래된 순: createTime,asc
 * - 인기순: popularity,desc
 */
export const mapTopicSortToServerSort = (sort: TTopicSort): string => {
  switch (sort) {
    case '인기순':
      return 'popularity,desc'
    case '오래된 순':
      return 'createTime,asc'
    default:
      return 'createTime,desc'
  }
}

export interface ITopicContentItem {
  id: number
  imageUrl: string
  title: string
}

/** 주제별 콘텐츠 필터 칩 (전체 = categoryId null) */
export interface ITopicFilter {
  categoryId: number | null
  label: string
}

/** 카테고리 목록 → 필터 칩 목록 ("전체" + sortOrder 순) */
export const toTopicFilters = (
  categories: IMycleContentCategory[]
): ITopicFilter[] => [
  { categoryId: null, label: ALL_TOPIC_FILTER },
  ...[...categories]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(category => ({ categoryId: category.serverId, label: category.name })),
]
